/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import * as React from 'react';
import PropTypes, { func } from "prop-types"
import { getImageURL } from '../../format-date';
import { Helmet } from 'react-helmet';
function SEO({ seoData }) {

  const baseURL = "https://www.ionicfirebaseapp.com/blogs/";
  seoData.url = seoData.url.startsWith("/") ? seoData.url.slice(1) : seoData.url;
  const pageURL = baseURL + seoData.url;
  // let productImages = [];
  // if (product_details) {
  //   product_details.product_images.forEach(p_image => {
  //     productImages.push(getImageURL(p_image.localFile.name, p_image.localFile.extension));
  //   });
  // }
  let filedUnder = "";
  if (seoData.type === "article") {
    // seoData.tags.forEach(tag => {
    //   filedUnder = !filedUnder.length ? tag.category_name : filedUnder.concat(`, ${tag.category_name}`);
    // });
  }
  let schema = null;
  if (seoData.schemaType === "Product") {
    schema = {
      "@context": "https://schema.org",
      "@type": "Article",
      publisher: {
        "@type": "Organization",
        "name": "Ionic Firebase App Blog: Get Updated with Technology, Development, Digital Marketing!",
        "url": "https://www.ionicfirebaseapp.com/blogs/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://ik.imagekit.io/qmvsc2gvr/ionicfirebaseapp/tr:dpr-auto,tr:w-auto/2020/03/logo2_bt9jkl.png",
          "width": 300,
          "height": 54
        }
      },
      "author": {
        "@type": "Person",
        "name": seoData.author.author_name,
        "image": {
          "@type": "ImageObject",
          "url": getImageURL(seoData.author.author_image.localFile.name, seoData.author.author_image.localFile.extension),
        },
        "url": `https://www.ionicfirebaseapp.com/blogs/author/${seoData.author.slug}/`,
        "sameAs": [
          "https://www.ionicfirebaseapp.com/blogs/",
          `https://twitter.com/${seoData.author.author_twitter_profile_name}`
        ]
      },
      "headline": seoData.title,
      "url": pageURL,
      "datePublished": seoData.publishedTime,
      "dateModified": seoData.modifiedTime,
      "image": {
        "@type": "ImageObject",
        "url": seoData.image,
        "width": 1200,
        "height": 900
      },
      "description": seoData.description,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.ionicfirebaseapp.com/blogs/"
      }
    }
  } else if (seoData.schemaType === "Series") {
    schema = {
      "@context": "https://schema.org",
      "@type": "Series",
      "publisher": {
        "@type": "Organization",
        "name": "Ionic Firebase App Blog: Get Updated with Technology, Development, Digital Marketing!",
        "url": "https://www.ionicfirebaseapp.com/blogs/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://ik.imagekit.io/qmvsc2gvr/ionicfirebaseapp/tr:dpr-auto,tr:w-auto/2020/03/logo2_bt9jkl.png",
          "width": 300,
          "height": 54
        }
      },
      "url": pageURL,
      "name": seoData.categoryName,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.ionicfirebaseapp.com/blogs/"
      }
    }
  } else if (seoData.schemaType === "Person") {
    schema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "sameAs": [
        "https://www.ionicfirebaseapp.com/blogs/",
        `https://twitter.com/${seoData.twitter_profile}`
      ],
      "name": seoData.authorName,
      "url": pageURL,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.ionicfirebaseapp.com/blogs/"
      },
      description: seoData.description
    }
  } else {
    schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "publisher": {
        "@type": "Organization",
        "name": "Ionic Firebase App Blog: Get Updated with Technology, Development, Digital Marketing!",
        "url": "https://www.ionicfirebaseapp.com/blogs/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://ik.imagekit.io/qmvsc2gvr/ionicfirebaseapp/tr:dpr-auto,tr:w-auto/2020/03/logo2_bt9jkl.png",
          "width": 300,
          "height": 54
        }
      },
      "url": pageURL,
      "image": {
        "@type": "ImageObject",
        "url": "https://ik.imagekit.io/qmvsc2gvr/ionicfirebaseapp/tr:dpr-auto,tr:w-auto/2020/03/vmnthmhy7f9bunot6d7f.jpg",
        "width": 2376,
        "height": 1182
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.ionicfirebaseapp.com/blogs/"
      },
      "description": seoData.description
    }
  }
  setTimeout(() => {
    if (typeof document !== "undefined") {
      if(!document.getElementById("intercom-messenger-widget")){
        console.log("INTERCOM SCRIPT ADDED");
        const intercomScript = document.createElement("script");
    intercomScript.id = "intercom-messenger-widget";
    intercomScript.src = "https://widget.intercom.io/widget/luioodji";
    intercomScript.onload = () => {
      window["intercomSettings"] = {
        api_base: "https://api-iam.intercom.io",
        app_id: "luioodji"
      };
      (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic("reattach_activator");
          ic("update", w.intercomSettings);
        } else {
          var d = document;
          var i = function() {
            i.c(arguments);
          };
          i.q = [];
          i.c = function(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function() {
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/luioodji";
            var x = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === "complete") {
            l();
          } else if (w.attachEvent) {
            w.attachEvent("onload", l);
          } else {
            w.addEventListener("load", l, false);
          }
        }
      })();
    };
    document.head.appendChild(intercomScript);
      }
    }

  }, 3000);
  return (
    <>
      <Helmet>
        <meta http-equiv="Accept-CH" content="DPR, Viewport-Width"></meta>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description}></meta>
        <meta property="og:site_name" content="Ionic Firebase App Blog: Get Updated with Technology, Development, Digital Marketing!" />
        <meta property="og:type" content={seoData.type} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:url" content={pageURL} />
        <meta property="og:image" content={seoData.image} />
        <meta property="article:publisher" content="https://www.facebook.com/ionicfirebaseapp" />
        <link rel="canonical" href={pageURL} />
        {seoData.publishedTime ? <meta property="article:published_time" content={seoData.publishedTime} /> : ''}
        {seoData.modifiedTime ? <meta property="article:modified_time" content={seoData.modifiedTime} /> : ''}
        {seoData.tags && seoData.tags.length
          ? seoData.tags.map(tag => (<meta property="article:tag" content={tag.category_name} key={tag.category_slug} />))
          : ''}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name='twitter:title' content={seoData.title}></meta>
        <meta name='twitter:description' content={seoData.description}></meta>
        <meta name='twitter:image' content={seoData.image}></meta>
        <meta name="twitter:url" content={pageURL} />
        <meta name="twitter:site" content="@ionicfirebaseap" />
        {seoData.twitter_profile ? <meta name="twitter:creator" content={seoData.twitter_profile} /> : ''}
        {seoData.type === "article" ?
          <meta name="twitter:label1" content="Written By" />
          : ''}
        {seoData.type === "article" ?
          <meta name="twitter:data1" content={`@${seoData.author.author_twitter_profile_name}`} />
          : ''}
        {/* {seoData.type === "article" ?
          <meta name="twitter:label2" content="Filed Under" />
          : ''}
        {seoData.type === "article" ?
          <meta name="twitter:data2" content={filedUnder} />
          : ''} */}
        <script type='application/ld+json'>
          {JSON.stringify(schema, null, 2)}
        </script>
      </Helmet>
    </>
  )
}

SEO.defaultProps = {
  seoData: {}
}

SEO.propTypes = {
  seoData: PropTypes.object
}

export default SEO
